var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCourseRocketIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 9.75C4.33732 9.90893 5.58229 10.5132 6.53457 11.4654C7.48685 12.4177 8.09107 13.6627 8.25 15C8.91294 14.6178 9.46747 14.0729 9.86117 13.4167C10.2549 12.7605 10.4747 12.0148 10.5 11.25C11.7593 10.807 12.859 10.0005 13.66 8.93251C14.461 7.86452 14.9273 6.583 15 5.25C15 4.65326 14.7629 4.08097 14.341 3.65901C13.919 3.23705 13.3467 3 12.75 3C11.417 3.07268 10.1355 3.539 9.06749 4.33999C7.9995 5.14098 7.19301 6.24067 6.75 7.5C5.9852 7.52526 5.23947 7.74513 4.5833 8.13883C3.92713 8.53253 3.38219 9.08706 3 9.75",
    stroke: "#25D076",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25012 10.5C4.46954 10.9407 3.83836 11.6044 3.43748 12.4062C3.03661 13.2079 2.88431 14.1111 3.00012 15C3.88899 15.1158 4.79219 14.9635 5.59393 14.5626C6.39568 14.1618 7.05944 13.5306 7.50012 12.75",
    stroke: "#25D076",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 7.5C11.6642 7.5 12 7.16421 12 6.75C12 6.33579 11.6642 6 11.25 6C10.8358 6 10.5 6.33579 10.5 6.75C10.5 7.16421 10.8358 7.5 11.25 7.5Z",
    stroke: "#25D076",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseRocketIcon);
export default __webpack_public_path__ + "static/media/course-rocket-icon.b5e423c06175f3f71d0710aa5c52de5c.svg";
export { ForwardRef as ReactComponent };